import React, { useRef } from 'react';
import * as S from './styles';
import { useWidth } from './hooks';

import { Spacer, Text } from '@zillow/constellation';
import HomeMarkerGray from '../images/icons/homeMarkerGray.inline.svg';
import { asCurrency } from '../utils/numberUtils';

export interface RentRangeChartProps {
  upperBound: number;
  lowerBound: number;
  zestimate: number;
}

const RentRangeChart: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<RentRangeChartProps>>> = (
  props,
) => {
  const { upperBound, lowerBound, zestimate } = props;
  const range = upperBound - lowerBound;
  const offset = zestimate - lowerBound;
  const lineRef = useRef<HTMLDivElement>(null);
  const lineWidthInPixels = useWidth(lineRef);

  return (
    <Spacer aria-hidden="true" marginBottom="sm">
      {lineWidthInPixels !== null && (
        <S.Marker numPixelsFromLeft={(offset / range) * lineWidthInPixels}>
          <S.Zestimate>{asCurrency(zestimate)}</S.Zestimate>
          <HomeMarkerGray />
        </S.Marker>
      )}
      <S.Line ref={lineRef} />
      <S.Flex>
        <S.Left>
          <Text as="strong" fontColor="gray500">
            {asCurrency(lowerBound)}
          </Text>
          <Text as="p" fontColor="gray500">
            Low
          </Text>
        </S.Left>
        <S.Right>
          <Text as="strong" fontColor="gray500">
            {asCurrency(upperBound)}
          </Text>
          <Text as="p" fontColor="gray500">
            High
          </Text>
        </S.Right>
      </S.Flex>
    </Spacer>
  );
};

export default RentRangeChart;
